const listaMunicipios = [
  {
    value: null,
    text: "-- Seleccione un Municipio --"
  },
  {
    value: "05002",
    text: "Abejorral - Antioquia"
  },
  {
    value: "54003",
    text: "\u00c1brego - Norte de Santander"
  },
  {
    value: "05004",
    text: "Abriaqu\u00ed - Antioquia"
  },
  {
    value: "50006",
    text: "Acac\u00edas - Meta"
  },
  {
    value: "27006",
    text: "Acand\u00ed - Choc\u00f3"
  },
  {
    value: "41006",
    text: "Acevedo - Huila"
  },
  {
    value: "13006",
    text: "Ach\u00ed - Bol\u00edvar"
  },
  {
    value: "41013",
    text: "Agrado - Huila"
  },
  {
    value: "25001",
    text: "Agua de Dios - Cundinamarca"
  },
  {
    value: "20011",
    text: "Aguachica - Cesar"
  },
  {
    value: "68013",
    text: "Aguada - Santander"
  },
  {
    value: "17013",
    text: "Aguadas - Caldas"
  },
  {
    value: "85010",
    text: "Aguazul - Casanare"
  },
  {
    value: "20013",
    text: "Agust\u00edn Codazzi - Cesar"
  },
  {
    value: "41016",
    text: "Aipe - Huila"
  },
  {
    value: "25019",
    text: "Alb\u00e1n - Cundinamarca"
  },
  {
    value: "52019",
    text: "Alb\u00e1n - Nari\u00f1o"
  },
  {
    value: "18029",
    text: "Albania - Caquet\u00e1"
  },
  {
    value: "44035",
    text: "Albania - La Guajira"
  },
  {
    value: "68020",
    text: "Albania - Santander"
  },
  {
    value: "76020",
    text: "Alcal\u00e1 - Valle del Cauca"
  },
  {
    value: "52022",
    text: "Aldana - Nari\u00f1o"
  },
  {
    value: "05021",
    text: "Alejandr\u00eda - Antioquia"
  },
  {
    value: "47030",
    text: "Algarrobo - Magdalena"
  },
  {
    value: "41020",
    text: "Algeciras - Huila"
  },
  {
    value: "19022",
    text: "Almaguer - Cauca"
  },
  {
    value: "15022",
    text: "Almeida - Boyac\u00e1"
  },
  {
    value: "73024",
    text: "Alpujarra - Tolima"
  },
  {
    value: "41026",
    text: "Altamira - Huila"
  },
  {
    value: "27025",
    text: "Alto Baud\u00f3 - Choc\u00f3"
  },
  {
    value: "13030",
    text: "Altos del Rosario - Bol\u00edvar"
  },
  {
    value: "73026",
    text: "Alvarado - Tolima"
  },
  {
    value: "05030",
    text: "Amag\u00e1 - Antioquia"
  },
  {
    value: "05031",
    text: "Amalfi - Antioquia"
  },
  {
    value: "73030",
    text: "Ambalema - Tolima"
  },
  {
    value: "25035",
    text: "Anapoima - Cundinamarca"
  },
  {
    value: "52036",
    text: "Ancuy\u00e1 - Nari\u00f1o"
  },
  {
    value: "76036",
    text: "Andaluc\u00eda - Valle del Cauca"
  },
  {
    value: "05034",
    text: "Andes - Antioquia"
  },
  {
    value: "05036",
    text: "Angel\u00f3polis - Antioquia"
  },
  {
    value: "05038",
    text: "Angostura - Antioquia"
  },
  {
    value: "25040",
    text: "Anolaima - Cundinamarca"
  },
  {
    value: "05040",
    text: "Anor\u00ed - Antioquia"
  },
  {
    value: "17042",
    text: "Anserma - Caldas"
  },
  {
    value: "76041",
    text: "Ansermanuevo - Valle del Cauca"
  },
  {
    value: "05044",
    text: "Anz\u00e1 - Antioquia"
  },
  {
    value: "73043",
    text: "Anzo\u00e1tegui - Tolima"
  },
  {
    value: "05045",
    text: "Apartad\u00f3 - Antioquia"
  },
  {
    value: "66045",
    text: "Ap\u00eda - Risaralda"
  },
  {
    value: "25599",
    text: "Apulo - Cundinamarca"
  },
  {
    value: "15047",
    text: "Aquitania - Boyac\u00e1"
  },
  {
    value: "47053",
    text: "Aracataca - Magdalena"
  },
  {
    value: "17050",
    text: "Aranzazu - Caldas"
  },
  {
    value: "68051",
    text: "Aratoca - Santander"
  },
  {
    value: "81001",
    text: "Arauca - Arauca"
  },
  {
    value: "81065",
    text: "Arauquita - Arauca"
  },
  {
    value: "25053",
    text: "Arbel\u00e1ez - Cundinamarca"
  },
  {
    value: "52051",
    text: "Arboleda - Nari\u00f1o"
  },
  {
    value: "54051",
    text: "Arboledas - Norte de Santander"
  },
  {
    value: "05051",
    text: "Arboletes - Antioquia"
  },
  {
    value: "15051",
    text: "Arcabuco - Boyac\u00e1"
  },
  {
    value: "13042",
    text: "Arenal - Bol\u00edvar"
  },
  {
    value: "05055",
    text: "Argelia - Antioquia"
  },
  {
    value: "19050",
    text: "Argelia - Cauca"
  },
  {
    value: "76054",
    text: "Argelia - Valle del Cauca"
  },
  {
    value: "47058",
    text: "Ariguan\u00ed - Magdalena"
  },
  {
    value: "13052",
    text: "Arjona - Bol\u00edvar"
  },
  {
    value: "05059",
    text: "Armenia - Antioquia"
  },
  {
    value: "63001",
    text: "Armenia - Quindio"
  },
  {
    value: "73055",
    text: "Armero  - Tolima"
  },
  {
    value: "13062",
    text: "Arroyohondo - Bol\u00edvar"
  },
  {
    value: "20032",
    text: "Astrea - Cesar"
  },
  {
    value: "73067",
    text: "Ataco - Tolima"
  },
  {
    value: "27050",
    text: "Atrato - Choc\u00f3"
  },
  {
    value: "23068",
    text: "Ayapel - C\u00f3rdoba"
  },
  {
    value: "27073",
    text: "Bagad\u00f3 - Choc\u00f3"
  },
  {
    value: "27075",
    text: "Bah\u00eda Solano - Choc\u00f3"
  },
  {
    value: "27077",
    text: "Bajo Baud\u00f3 - Choc\u00f3"
  },
  {
    value: "19075",
    text: "Balboa - Cauca"
  },
  {
    value: "66075",
    text: "Balboa - Risaralda"
  },
  {
    value: "08078",
    text: "Baranoa - Atl\u00e1ntico"
  },
  {
    value: "41078",
    text: "Baraya - Huila"
  },
  {
    value: "52079",
    text: "Barbacoas - Nari\u00f1o"
  },
  {
    value: "05079",
    text: "Barbosa - Antioquia"
  },
  {
    value: "68077",
    text: "Barbosa - Santander"
  },
  {
    value: "68079",
    text: "Barichara - Santander"
  },
  {
    value: "50110",
    text: "Barranca de Up\u00eda - Meta"
  },
  {
    value: "68081",
    text: "Barrancabermeja - Santander"
  },
  {
    value: "44078",
    text: "Barrancas - La Guajira"
  },
  {
    value: "13074",
    text: "Barranco de Loba - Bol\u00edvar"
  },
  {
    value: "94343",
    text: "Barranco Minas - Guain\u00eda"
  },
  {
    value: "08001",
    text: "Barranquilla - Atl\u00e1ntico"
  },
  {
    value: "20045",
    text: "Becerril - Cesar"
  },
  {
    value: "17088",
    text: "Belalc\u00e1zar - Caldas"
  },
  {
    value: "15087",
    text: "Bel\u00e9n - Boyac\u00e1"
  },
  {
    value: "52083",
    text: "Bel\u00e9n - Nari\u00f1o"
  },
  {
    value: "18094",
    text: "Bel\u00e9n de los Andaqu\u00edes - Caquet\u00e1"
  },
  {
    value: "66088",
    text: "Bel\u00e9n de Umbr\u00eda - Risaralda"
  },
  {
    value: "05088",
    text: "Bello - Antioquia"
  },
  {
    value: "05086",
    text: "Belmira - Antioquia"
  },
  {
    value: "25086",
    text: "Beltr\u00e1n - Cundinamarca"
  },
  {
    value: "15090",
    text: "Berbeo - Boyac\u00e1"
  },
  {
    value: "05091",
    text: "Betania - Antioquia"
  },
  {
    value: "15092",
    text: "Bet\u00e9itiva - Boyac\u00e1"
  },
  {
    value: "05093",
    text: "Betulia - Antioquia"
  },
  {
    value: "68092",
    text: "Betulia - Santander"
  },
  {
    value: "25095",
    text: "Bituima - Cundinamarca"
  },
  {
    value: "15097",
    text: "Boavita - Boyac\u00e1"
  },
  {
    value: "54099",
    text: "Bochalema - Norte de Santander"
  },
  {
    value: "11001",
    text: "Bogot\u00e1 D.C. - Bogot\u00e1 Distrito Capital"
  },
  {
    value: "25099",
    text: "Bojac\u00e1 - Cundinamarca"
  },
  {
    value: "27099",
    text: "Bojay\u00e1 - Choc\u00f3"
  },
  {
    value: "19100",
    text: "Bol\u00edvar - Cauca"
  },
  {
    value: "68101",
    text: "Bol\u00edvar - Santander"
  },
  {
    value: "76100",
    text: "Bol\u00edvar - Valle del Cauca"
  },
  {
    value: "20060",
    text: "Bosconia - Cesar"
  },
  {
    value: "15104",
    text: "Boyac\u00e1 - Boyac\u00e1"
  },
  {
    value: "05107",
    text: "Brice\u00f1o - Antioquia"
  },
  {
    value: "15106",
    text: "Brice\u00f1o - Boyac\u00e1"
  },
  {
    value: "68001",
    text: "Bucaramanga - Santander"
  },
  {
    value: "54109",
    text: "Bucarasica - Norte de Santander"
  },
  {
    value: "76109",
    text: "Buenaventura - Valle del Cauca"
  },
  {
    value: "15109",
    text: "Buenavista - Boyac\u00e1"
  },
  {
    value: "23079",
    text: "Buenavista - C\u00f3rdoba"
  },
  {
    value: "63111",
    text: "Buenavista - Quindio"
  },
  {
    value: "70110",
    text: "Buenavista - Sucre"
  },
  {
    value: "19110",
    text: "Buenos Aires - Cauca"
  },
  {
    value: "52110",
    text: "Buesaco - Nari\u00f1o"
  },
  {
    value: "76113",
    text: "Bugalagrande - Valle del Cauca"
  },
  {
    value: "05113",
    text: "Buritic\u00e1 - Antioquia"
  },
  {
    value: "15114",
    text: "Busbanz\u00e1 - Boyac\u00e1"
  },
  {
    value: "25120",
    text: "Cabrera - Cundinamarca"
  },
  {
    value: "68121",
    text: "Cabrera - Santander"
  },
  {
    value: "50124",
    text: "Cabuyaro - Meta"
  },
  {
    value: "94886",
    text: "Cacahual - Guain\u00eda"
  },
  {
    value: "05120",
    text: "C\u00e1ceres - Antioquia"
  },
  {
    value: "25123",
    text: "Cachipay - Cundinamarca"
  },
  {
    value: "54128",
    text: "C\u00e1chira - Norte de Santander"
  },
  {
    value: "54125",
    text: "C\u00e1cota - Norte de Santander"
  },
  {
    value: "05125",
    text: "Caicedo - Antioquia"
  },
  {
    value: "76122",
    text: "Caicedonia - Valle del Cauca"
  },
  {
    value: "70124",
    text: "Caimito - Sucre"
  },
  {
    value: "73124",
    text: "Cajamarca - Tolima"
  },
  {
    value: "19130",
    text: "Cajib\u00edo - Cauca"
  },
  {
    value: "25126",
    text: "Cajic\u00e1 - Cundinamarca"
  },
  {
    value: "13140",
    text: "Calamar - Bol\u00edvar"
  },
  {
    value: "95015",
    text: "Calamar - Guaviare"
  },
  {
    value: "63130",
    text: "Calarc\u00e1 - Quindio"
  },
  {
    value: "05129",
    text: "Caldas - Antioquia"
  },
  {
    value: "15131",
    text: "Caldas - Boyac\u00e1"
  },
  {
    value: "19137",
    text: "Caldono - Cauca"
  },
  {
    value: "76001",
    text: "Cali - Valle del Cauca"
  },
  {
    value: "68132",
    text: "California - Santander"
  },
  {
    value: "76126",
    text: "Calima - Valle del Cauca"
  },
  {
    value: "19142",
    text: "Caloto - Cauca"
  },
  {
    value: "05134",
    text: "Campamento - Antioquia"
  },
  {
    value: "08137",
    text: "Campo de la Cruz - Atl\u00e1ntico"
  },
  {
    value: "41132",
    text: "Campoalegre - Huila"
  },
  {
    value: "15135",
    text: "Campohermoso - Boyac\u00e1"
  },
  {
    value: "23090",
    text: "Canalete - C\u00f3rdoba"
  },
  {
    value: "05138",
    text: "Ca\u00f1asgordas - Antioquia"
  },
  {
    value: "08141",
    text: "Candelaria - Atl\u00e1ntico"
  },
  {
    value: "76130",
    text: "Candelaria - Valle del Cauca"
  },
  {
    value: "13160",
    text: "Cantagallo - Bol\u00edvar"
  },
  {
    value: "25148",
    text: "Caparrap\u00ed - Cundinamarca"
  },
  {
    value: "68147",
    text: "Capitanejo - Santander"
  },
  {
    value: "25151",
    text: "C\u00e1queza - Cundinamarca"
  },
  {
    value: "05142",
    text: "Caracol\u00ed - Antioquia"
  },
  {
    value: "05145",
    text: "Caramanta - Antioquia"
  },
  {
    value: "68152",
    text: "Carcas\u00ed - Santander"
  },
  {
    value: "05147",
    text: "Carepa - Antioquia"
  },
  {
    value: "73148",
    text: "Carmen de Apical\u00e1 - Tolima"
  },
  {
    value: "25154",
    text: "Carmen de Carupa - Cundinamarca"
  },
  {
    value: "27150",
    text: "Carmen del Dari\u00e9n - Choc\u00f3"
  },
  {
    value: "05150",
    text: "Carolina - Antioquia"
  },
  {
    value: "13001",
    text: "Cartagena de Indias - Bol\u00edvar"
  },
  {
    value: "18150",
    text: "Cartagena del Chair\u00e1 - Caquet\u00e1"
  },
  {
    value: "76147",
    text: "Cartago - Valle del Cauca"
  },
  {
    value: "97161",
    text: "Carur\u00fa - Vaup\u00e9s"
  },
  {
    value: "73152",
    text: "Casabianca - Tolima"
  },
  {
    value: "50150",
    text: "Castilla la Nueva - Meta"
  },
  {
    value: "05154",
    text: "Caucasia - Antioquia"
  },
  {
    value: "68160",
    text: "Cepit\u00e1 - Santander"
  },
  {
    value: "23162",
    text: "Ceret\u00e9 - C\u00f3rdoba"
  },
  {
    value: "15162",
    text: "Cerinza - Boyac\u00e1"
  },
  {
    value: "68162",
    text: "Cerrito - Santander"
  },
  {
    value: "47161",
    text: "Cerro de San Antonio - Magdalena"
  },
  {
    value: "27160",
    text: "C\u00e9rtegui - Choc\u00f3"
  },
  {
    value: "52240",
    text: "Chachag\u00fc\u00ed - Nari\u00f1o"
  },
  {
    value: "25168",
    text: "Chaguan\u00ed - Cundinamarca"
  },
  {
    value: "70230",
    text: "Chal\u00e1n - Sucre"
  },
  {
    value: "85015",
    text: "Ch\u00e1meza - Casanare"
  },
  {
    value: "73168",
    text: "Chaparral - Tolima"
  },
  {
    value: "68167",
    text: "Charal\u00e1 - Santander"
  },
  {
    value: "68169",
    text: "Charta - Santander"
  },
  {
    value: "25175",
    text: "Ch\u00eda - Cundinamarca"
  },
  {
    value: "05172",
    text: "Chigorod\u00f3 - Antioquia"
  },
  {
    value: "23168",
    text: "Chim\u00e1 - C\u00f3rdoba"
  },
  {
    value: "68176",
    text: "Chima - Santander"
  },
  {
    value: "20175",
    text: "Chimichagua - Cesar"
  },
  {
    value: "54172",
    text: "Chin\u00e1cota - Norte de Santander"
  },
  {
    value: "15172",
    text: "Chinavita - Boyac\u00e1"
  },
  {
    value: "17174",
    text: "Chinchin\u00e1 - Caldas"
  },
  {
    value: "23182",
    text: "Chin\u00fa - C\u00f3rdoba"
  },
  {
    value: "25178",
    text: "Chipaque - Cundinamarca"
  },
  {
    value: "68179",
    text: "Chipat\u00e1 - Santander"
  },
  {
    value: "15176",
    text: "Chiquinquir\u00e1 - Boyac\u00e1"
  },
  {
    value: "15232",
    text: "Ch\u00edquiza - Boyac\u00e1"
  },
  {
    value: "20178",
    text: "Chiriguan\u00e1 - Cesar"
  },
  {
    value: "15180",
    text: "Chiscas - Boyac\u00e1"
  },
  {
    value: "15183",
    text: "Chita - Boyac\u00e1"
  },
  {
    value: "54174",
    text: "Chitag\u00e1 - Norte de Santander"
  },
  {
    value: "15185",
    text: "Chitaraque - Boyac\u00e1"
  },
  {
    value: "15187",
    text: "Chivat\u00e1 - Boyac\u00e1"
  },
  {
    value: "47170",
    text: "Chivolo - Magdalena"
  },
  {
    value: "15236",
    text: "Chivor - Boyac\u00e1"
  },
  {
    value: "25181",
    text: "Choach\u00ed - Cundinamarca"
  },
  {
    value: "25183",
    text: "Chocont\u00e1 - Cundinamarca"
  },
  {
    value: "13188",
    text: "Cicuco - Bol\u00edvar"
  },
  {
    value: "47189",
    text: "Ci\u00e9naga - Magdalena"
  },
  {
    value: "23189",
    text: "Ci\u00e9naga de Oro - C\u00f3rdoba"
  },
  {
    value: "15189",
    text: "Ci\u00e9nega - Boyac\u00e1"
  },
  {
    value: "68190",
    text: "Cimitarra - Santander"
  },
  {
    value: "63190",
    text: "Circasia - Quindio"
  },
  {
    value: "05190",
    text: "Cisneros - Antioquia"
  },
  {
    value: "05101",
    text: "Ciudad Bol\u00edvar - Antioquia"
  },
  {
    value: "13222",
    text: "Clemencia - Bol\u00edvar"
  },
  {
    value: "05197",
    text: "Cocorn\u00e1 - Antioquia"
  },
  {
    value: "73200",
    text: "Coello - Tolima"
  },
  {
    value: "25200",
    text: "Cogua - Cundinamarca"
  },
  {
    value: "41206",
    text: "Colombia - Huila"
  },
  {
    value: "52203",
    text: "Col\u00f3n - Nari\u00f1o"
  },
  {
    value: "86219",
    text: "Col\u00f3n - Putumayo"
  },
  {
    value: "70204",
    text: "Coloso - Sucre"
  },
  {
    value: "15204",
    text: "C\u00f3mbita - Boyac\u00e1"
  },
  {
    value: "05206",
    text: "Concepci\u00f3n - Antioquia"
  },
  {
    value: "68207",
    text: "Concepci\u00f3n - Santander"
  },
  {
    value: "05209",
    text: "Concordia - Antioquia"
  },
  {
    value: "47205",
    text: "Concordia - Magdalena"
  },
  {
    value: "27205",
    text: "Condoto - Choc\u00f3"
  },
  {
    value: "68209",
    text: "Confines - Santander"
  },
  {
    value: "52207",
    text: "Consac\u00e1 - Nari\u00f1o"
  },
  {
    value: "52210",
    text: "Contadero - Nari\u00f1o"
  },
  {
    value: "68211",
    text: "Contrataci\u00f3n - Santander"
  },
  {
    value: "54206",
    text: "Convenci\u00f3n - Norte de Santander"
  },
  {
    value: "05212",
    text: "Copacabana - Antioquia"
  },
  {
    value: "15212",
    text: "Coper - Boyac\u00e1"
  },
  {
    value: "13212",
    text: "C\u00f3rdoba - Bol\u00edvar"
  },
  {
    value: "52215",
    text: "C\u00f3rdoba - Nari\u00f1o"
  },
  {
    value: "63212",
    text: "C\u00f3rdoba - Quindio"
  },
  {
    value: "19212",
    text: "Corinto - Cauca"
  },
  {
    value: "68217",
    text: "Coromoro - Santander"
  },
  {
    value: "70215",
    text: "Corozal - Sucre"
  },
  {
    value: "15215",
    text: "Corrales - Boyac\u00e1"
  },
  {
    value: "25214",
    text: "Cota - Cundinamarca"
  },
  {
    value: "23300",
    text: "Cotorra - C\u00f3rdoba"
  },
  {
    value: "15218",
    text: "Covarach\u00eda - Boyac\u00e1"
  },
  {
    value: "70221",
    text: "Cove\u00f1as - Sucre"
  },
  {
    value: "73217",
    text: "Coyaima - Tolima"
  },
  {
    value: "81220",
    text: "Cravo Norte - Arauca"
  },
  {
    value: "52224",
    text: "Cuasp\u00fad - Nari\u00f1o"
  },
  {
    value: "15223",
    text: "Cubar\u00e1 - Boyac\u00e1"
  },
  {
    value: "15224",
    text: "Cucaita - Boyac\u00e1"
  },
  {
    value: "25224",
    text: "Cucunub\u00e1 - Cundinamarca"
  },
  {
    value: "54001",
    text: "C\u00facuta - Norte de Santander"
  },
  {
    value: "54223",
    text: "Cucutilla - Norte de Santander"
  },
  {
    value: "15226",
    text: "Cu\u00edtiva - Boyac\u00e1"
  },
  {
    value: "50226",
    text: "Cumaral - Meta"
  },
  {
    value: "99773",
    text: "Cumaribo - Vichada"
  },
  {
    value: "52227",
    text: "Cumbal - Nari\u00f1o"
  },
  {
    value: "52233",
    text: "Cumbitara - Nari\u00f1o"
  },
  {
    value: "73226",
    text: "Cunday - Tolima"
  },
  {
    value: "18205",
    text: "Curillo - Caquet\u00e1"
  },
  {
    value: "68229",
    text: "Curit\u00ed - Santander"
  },
  {
    value: "20228",
    text: "Curuman\u00ed - Cesar"
  },
  {
    value: "05234",
    text: "Dabeiba - Antioquia"
  },
  {
    value: "76233",
    text: "Dagua - Valle del Cauca"
  },
  {
    value: "44090",
    text: "Dibulla - La Guajira"
  },
  {
    value: "44098",
    text: "Distracci\u00f3n - La Guajira"
  },
  {
    value: "73236",
    text: "Dolores - Tolima"
  },
  {
    value: "05237",
    text: "Donmat\u00edas - Antioquia"
  },
  {
    value: "66170",
    text: "Dosquebradas - Risaralda"
  },
  {
    value: "15238",
    text: "Duitama - Boyac\u00e1"
  },
  {
    value: "54239",
    text: "Durania - Norte de Santander"
  },
  {
    value: "05240",
    text: "Eb\u00e9jico - Antioquia"
  },
  {
    value: "76243",
    text: "El \u00c1guila - Valle del Cauca"
  },
  {
    value: "05250",
    text: "El Bagre - Antioquia"
  },
  {
    value: "47245",
    text: "El Banco - Magdalena"
  },
  {
    value: "76246",
    text: "El Cairo - Valle del Cauca"
  },
  {
    value: "50245",
    text: "El Calvario - Meta"
  },
  {
    value: "27135",
    text: "El Cant\u00f3n San Pablo - Choc\u00f3"
  },
  {
    value: "54245",
    text: "El Carmen - Norte de Santander"
  },
  {
    value: "27245",
    text: "El Carmen de Atrato - Choc\u00f3"
  },
  {
    value: "13244",
    text: "El Carmen de Bol\u00edvar - Bol\u00edvar"
  },
  {
    value: "68235",
    text: "El Carmen de Chucur\u00ed - Santander"
  },
  {
    value: "05148",
    text: "El Carmen de Viboral - Antioquia"
  },
  {
    value: "50251",
    text: "El Castillo - Meta"
  },
  {
    value: "76248",
    text: "El Cerrito - Valle del Cauca"
  },
  {
    value: "52250",
    text: "El Charco - Nari\u00f1o"
  },
  {
    value: "15244",
    text: "El Cocuy - Boyac\u00e1"
  },
  {
    value: "25245",
    text: "El Colegio - Cundinamarca"
  },
  {
    value: "20238",
    text: "El Copey - Cesar"
  },
  {
    value: "18247",
    text: "El Doncello - Caquet\u00e1"
  },
  {
    value: "50270",
    text: "El Dorado - Meta"
  },
  {
    value: "76250",
    text: "El Dovio - Valle del Cauca"
  },
  {
    value: "91263",
    text: "El Encanto - Amazonas"
  },
  {
    value: "15248",
    text: "El Espino - Boyac\u00e1"
  },
  {
    value: "68245",
    text: "El Guacamayo - Santander"
  },
  {
    value: "13248",
    text: "El Guamo - Bol\u00edvar"
  },
  {
    value: "27250",
    text: "El Litoral San Juan - Choc\u00f3"
  },
  {
    value: "44110",
    text: "El Molino - La Guajira"
  },
  {
    value: "20250",
    text: "El Paso - Cesar"
  },
  {
    value: "18256",
    text: "El Pauj\u00edl - Caquet\u00e1"
  },
  {
    value: "52254",
    text: "El Pe\u00f1ol - Nari\u00f1o"
  },
  {
    value: "13268",
    text: "El Pe\u00f1\u00f3n - Bol\u00edvar"
  },
  {
    value: "25258",
    text: "El Pe\u00f1\u00f3n - Cundinamarca"
  },
  {
    value: "68250",
    text: "El Pe\u00f1\u00f3n - Santander"
  },
  {
    value: "47258",
    text: "El Pi\u00f1\u00f3n - Magdalena"
  },
  {
    value: "68255",
    text: "El Play\u00f3n - Santander"
  },
  {
    value: "47268",
    text: "El Ret\u00e9n - Magdalena"
  },
  {
    value: "95025",
    text: "El Retorno - Guaviare"
  },
  {
    value: "70233",
    text: "El Roble - Sucre"
  },
  {
    value: "25260",
    text: "El Rosal - Cundinamarca"
  },
  {
    value: "52256",
    text: "El Rosario - Nari\u00f1o"
  },
  {
    value: "05697",
    text: "El Santuario - Antioquia"
  },
  {
    value: "52258",
    text: "El Tabl\u00f3n de G\u00f3mez - Nari\u00f1o"
  },
  {
    value: "19256",
    text: "El Tambo - Cauca"
  },
  {
    value: "52260",
    text: "El Tambo - Nari\u00f1o"
  },
  {
    value: "54250",
    text: "El Tarra - Norte de Santander"
  },
  {
    value: "54261",
    text: "El Zulia - Norte de Santander"
  },
  {
    value: "41244",
    text: "El\u00edas - Huila"
  },
  {
    value: "68264",
    text: "Encino - Santander"
  },
  {
    value: "68266",
    text: "Enciso - Santander"
  },
  {
    value: "05264",
    text: "Entrerr\u00edos - Antioquia"
  },
  {
    value: "05266",
    text: "Envigado - Antioquia"
  },
  {
    value: "73268",
    text: "Espinal - Tolima"
  },
  {
    value: "25269",
    text: "Facatativ\u00e1 - Cundinamarca"
  },
  {
    value: "73270",
    text: "Falan - Tolima"
  },
  {
    value: "17272",
    text: "Filadelfia - Caldas"
  },
  {
    value: "63272",
    text: "Filandia - Quindio"
  },
  {
    value: "15272",
    text: "Firavitoba - Boyac\u00e1"
  },
  {
    value: "73275",
    text: "Flandes - Tolima"
  },
  {
    value: "18001",
    text: "Florencia - Caquet\u00e1"
  },
  {
    value: "19290",
    text: "Florencia - Cauca"
  },
  {
    value: "15276",
    text: "Floresta - Boyac\u00e1"
  },
  {
    value: "68271",
    text: "Flori\u00e1n - Santander"
  },
  {
    value: "76275",
    text: "Florida - Valle del Cauca"
  },
  {
    value: "68276",
    text: "Floridablanca - Santander"
  },
  {
    value: "25279",
    text: "F\u00f3meque - Cundinamarca"
  },
  {
    value: "44279",
    text: "Fonseca - La Guajira"
  },
  {
    value: "81300",
    text: "Fortul - Arauca"
  },
  {
    value: "25281",
    text: "Fosca - Cundinamarca"
  },
  {
    value: "52520",
    text: "Francisco Pizarro - Nari\u00f1o"
  },
  {
    value: "05282",
    text: "Fredonia - Antioquia"
  },
  {
    value: "73283",
    text: "Fresno - Tolima"
  },
  {
    value: "05284",
    text: "Frontino - Antioquia"
  },
  {
    value: "50287",
    text: "Fuente de Oro - Meta"
  },
  {
    value: "47288",
    text: "Fundaci\u00f3n - Magdalena"
  },
  {
    value: "52287",
    text: "Funes - Nari\u00f1o"
  },
  {
    value: "25286",
    text: "Funza - Cundinamarca"
  },
  {
    value: "25288",
    text: "F\u00faquene - Cundinamarca"
  },
  {
    value: "25290",
    text: "Fusagasug\u00e1 - Cundinamarca"
  },
  {
    value: "25293",
    text: "Gachal\u00e1 - Cundinamarca"
  },
  {
    value: "25295",
    text: "Gachancip\u00e1 - Cundinamarca"
  },
  {
    value: "15293",
    text: "Gachantiv\u00e1 - Boyac\u00e1"
  },
  {
    value: "25297",
    text: "Gachet\u00e1 - Cundinamarca"
  },
  {
    value: "68296",
    text: "Gal\u00e1n - Santander"
  },
  {
    value: "08296",
    text: "Galapa - Atl\u00e1ntico"
  },
  {
    value: "70235",
    text: "Galeras - Sucre"
  },
  {
    value: "25299",
    text: "Gama - Cundinamarca"
  },
  {
    value: "20295",
    text: "Gamarra - Cesar"
  },
  {
    value: "68298",
    text: "G\u00e1mbita - Santander"
  },
  {
    value: "15296",
    text: "G\u00e1meza - Boyac\u00e1"
  },
  {
    value: "15299",
    text: "Garagoa - Boyac\u00e1"
  },
  {
    value: "41298",
    text: "Garz\u00f3n - Huila"
  },
  {
    value: "63302",
    text: "G\u00e9nova - Quindio"
  },
  {
    value: "41306",
    text: "Gigante - Huila"
  },
  {
    value: "76306",
    text: "Ginebra - Valle del Cauca"
  },
  {
    value: "05306",
    text: "Giraldo - Antioquia"
  },
  {
    value: "25307",
    text: "Girardot - Cundinamarca"
  },
  {
    value: "05308",
    text: "Girardota - Antioquia"
  },
  {
    value: "68307",
    text: "Gir\u00f3n - Santander"
  },
  {
    value: "05310",
    text: "G\u00f3mez Plata - Antioquia"
  },
  {
    value: "20310",
    text: "Gonz\u00e1lez - Cesar"
  },
  {
    value: "54313",
    text: "Gramalote - Norte de Santander"
  },
  {
    value: "05313",
    text: "Granada - Antioquia"
  },
  {
    value: "25312",
    text: "Granada - Cundinamarca"
  },
  {
    value: "50313",
    text: "Granada - Meta"
  },
  {
    value: "68318",
    text: "Guaca - Santander"
  },
  {
    value: "15317",
    text: "Guacamayas - Boyac\u00e1"
  },
  {
    value: "76318",
    text: "Guacar\u00ed - Valle del Cauca"
  },
  {
    value: "19300",
    text: "Guachen\u00e9 - Cauca"
  },
  {
    value: "25317",
    text: "Guachet\u00e1 - Cundinamarca"
  },
  {
    value: "52317",
    text: "Guachucal - Nari\u00f1o"
  },
  {
    value: "76111",
    text: "Guadalajara de Buga - Valle del Cauca"
  },
  {
    value: "05315",
    text: "Guadalupe - Antioquia"
  },
  {
    value: "41319",
    text: "Guadalupe - Huila"
  },
  {
    value: "68320",
    text: "Guadalupe - Santander"
  },
  {
    value: "25320",
    text: "Guaduas - Cundinamarca"
  },
  {
    value: "52320",
    text: "Guaitarilla - Nari\u00f1o"
  },
  {
    value: "52323",
    text: "Gualmat\u00e1n - Nari\u00f1o"
  },
  {
    value: "47318",
    text: "Guamal - Magdalena"
  },
  {
    value: "50318",
    text: "Guamal - Meta"
  },
  {
    value: "73319",
    text: "Guamo - Tolima"
  },
  {
    value: "19318",
    text: "Guap\u00ed - Cauca"
  },
  {
    value: "68322",
    text: "Guapot\u00e1 - Santander"
  },
  {
    value: "70265",
    text: "Guaranda - Sucre"
  },
  {
    value: "05318",
    text: "Guarne - Antioquia"
  },
  {
    value: "25322",
    text: "Guasca - Cundinamarca"
  },
  {
    value: "05321",
    text: "Guatap\u00e9 - Antioquia"
  },
  {
    value: "25324",
    text: "Guataqu\u00ed - Cundinamarca"
  },
  {
    value: "25326",
    text: "Guatavita - Cundinamarca"
  },
  {
    value: "15322",
    text: "Guateque - Boyac\u00e1"
  },
  {
    value: "66318",
    text: "Gu\u00e1tica - Risaralda"
  },
  {
    value: "68324",
    text: "Guavat\u00e1 - Santander"
  },
  {
    value: "25328",
    text: "Guayabal de S\u00edquima - Cundinamarca"
  },
  {
    value: "25335",
    text: "Guayabetal - Cundinamarca"
  },
  {
    value: "15325",
    text: "Guayat\u00e1 - Boyac\u00e1"
  },
  {
    value: "68327",
    text: "G\u00fcepsa - Santander"
  },
  {
    value: "15332",
    text: "G\u00fcic\u00e1n - Boyac\u00e1"
  },
  {
    value: "25339",
    text: "Guti\u00e9rrez - Cundinamarca"
  },
  {
    value: "54344",
    text: "Hacar\u00ed - Norte de Santander"
  },
  {
    value: "13300",
    text: "Hatillo de Loba - Bol\u00edvar"
  },
  {
    value: "68344",
    text: "Hato - Santander"
  },
  {
    value: "85125",
    text: "Hato Corozal - Casanare"
  },
  {
    value: "44378",
    text: "Hatonuevo - La Guajira"
  },
  {
    value: "05347",
    text: "Heliconia - Antioquia"
  },
  {
    value: "54347",
    text: "Herr\u00e1n - Norte de Santander"
  },
  {
    value: "73347",
    text: "Herveo - Tolima"
  },
  {
    value: "05353",
    text: "Hispania - Antioquia"
  },
  {
    value: "41349",
    text: "Hobo - Huila"
  },
  {
    value: "73349",
    text: "Honda - Tolima"
  },
  {
    value: "73001",
    text: "Ibagu\u00e9 - Tolima"
  },
  {
    value: "73352",
    text: "Icononzo - Tolima"
  },
  {
    value: "52352",
    text: "Iles - Nari\u00f1o"
  },
  {
    value: "52354",
    text: "Imu\u00e9s - Nari\u00f1o"
  },
  {
    value: "94001",
    text: "In\u00edrida - Guain\u00eda"
  },
  {
    value: "19355",
    text: "Inz\u00e1 - Cauca"
  },
  {
    value: "52356",
    text: "Ipiales - Nari\u00f1o"
  },
  {
    value: "41357",
    text: "\u00cdquira - Huila"
  },
  {
    value: "41359",
    text: "Isnos - Huila"
  },
  {
    value: "27361",
    text: "Istmina - Choc\u00f3"
  },
  {
    value: "05360",
    text: "Itag\u00fc\u00ed - Antioquia"
  },
  {
    value: "05361",
    text: "Ituango - Antioquia"
  },
  {
    value: "15362",
    text: "Iza - Boyac\u00e1"
  },
  {
    value: "19364",
    text: "Jambal\u00f3 - Cauca"
  },
  {
    value: "76364",
    text: "Jamund\u00ed - Valle del Cauca"
  },
  {
    value: "05364",
    text: "Jard\u00edn - Antioquia"
  },
  {
    value: "15367",
    text: "Jenesano - Boyac\u00e1"
  },
  {
    value: "05368",
    text: "Jeric\u00f3 - Antioquia"
  },
  {
    value: "15368",
    text: "Jeric\u00f3 - Boyac\u00e1"
  },
  {
    value: "25368",
    text: "Jerusal\u00e9n - Cundinamarca"
  },
  {
    value: "68368",
    text: "Jes\u00fas Mar\u00eda - Santander"
  },
  {
    value: "68370",
    text: "Jord\u00e1n - Santander"
  },
  {
    value: "08372",
    text: "Juan de Acosta - Atl\u00e1ntico"
  },
  {
    value: "25372",
    text: "Jun\u00edn - Cundinamarca"
  },
  {
    value: "27372",
    text: "Jurad\u00f3 - Choc\u00f3"
  },
  {
    value: "23350",
    text: "La Apartada - C\u00f3rdoba"
  },
  {
    value: "41378",
    text: "La Argentina - Huila"
  },
  {
    value: "68377",
    text: "La Belleza - Santander"
  },
  {
    value: "25377",
    text: "La Calera - Cundinamarca"
  },
  {
    value: "15380",
    text: "La Capilla - Boyac\u00e1"
  },
  {
    value: "05376",
    text: "La Ceja - Antioquia"
  },
  {
    value: "66383",
    text: "La Celia - Risaralda"
  },
  {
    value: "91405",
    text: "La Chorrera - Amazonas"
  },
  {
    value: "52378",
    text: "La Cruz - Nari\u00f1o"
  },
  {
    value: "76377",
    text: "La Cumbre - Valle del Cauca"
  },
  {
    value: "17380",
    text: "La Dorada - Caldas"
  },
  {
    value: "54385",
    text: "La Esperanza - Norte de Santander"
  },
  {
    value: "05380",
    text: "La Estrella - Antioquia"
  },
  {
    value: "52381",
    text: "La Florida - Nari\u00f1o"
  },
  {
    value: "20383",
    text: "La Gloria - Cesar"
  },
  {
    value: "94885",
    text: "La Guadalupe - Guain\u00eda"
  },
  {
    value: "20400",
    text: "La Jagua de Ibirico - Cesar"
  },
  {
    value: "44420",
    text: "La Jagua del Pilar - La Guajira"
  },
  {
    value: "52385",
    text: "La Llanada - Nari\u00f1o"
  },
  {
    value: "50350",
    text: "La Macarena - Meta"
  },
  {
    value: "17388",
    text: "La Merced - Caldas"
  },
  {
    value: "25386",
    text: "La Mesa - Cundinamarca"
  },
  {
    value: "18410",
    text: "La Monta\u00f1ita - Caquet\u00e1"
  },
  {
    value: "25394",
    text: "La Palma - Cundinamarca"
  },
  {
    value: "20621",
    text: "La Paz - Cesar"
  },
  {
    value: "68397",
    text: "La Paz - Santander"
  },
  {
    value: "91407",
    text: "La Pedrera - Amazonas"
  },
  {
    value: "25398",
    text: "La Pe\u00f1a - Cundinamarca"
  },
  {
    value: "05390",
    text: "La Pintada - Antioquia"
  },
  {
    value: "41396",
    text: "La Plata - Huila"
  },
  {
    value: "54398",
    text: "La Playa - Norte de Santander"
  },
  {
    value: "99524",
    text: "La Primavera - Vichada"
  },
  {
    value: "85136",
    text: "La Salina - Casanare"
  },
  {
    value: "19392",
    text: "La Sierra - Cauca"
  },
  {
    value: "63401",
    text: "La Tebaida - Quindio"
  },
  {
    value: "52390",
    text: "La Tola - Nari\u00f1o"
  },
  {
    value: "05400",
    text: "La Uni\u00f3n - Antioquia"
  },
  {
    value: "52399",
    text: "La Uni\u00f3n - Nari\u00f1o"
  },
  {
    value: "70400",
    text: "La Uni\u00f3n - Sucre"
  },
  {
    value: "76400",
    text: "La Uni\u00f3n - Valle del Cauca"
  },
  {
    value: "15403",
    text: "La Uvita - Boyac\u00e1"
  },
  {
    value: "19397",
    text: "La Vega - Cauca"
  },
  {
    value: "25402",
    text: "La Vega - Cundinamarca"
  },
  {
    value: "91430",
    text: "La Victoria - Amazonas"
  },
  {
    value: "15401",
    text: "La Victoria - Boyac\u00e1"
  },
  {
    value: "76403",
    text: "La Victoria - Valle del Cauca"
  },
  {
    value: "66400",
    text: "La Virginia - Risaralda"
  },
  {
    value: "54377",
    text: "Labateca - Norte de Santander"
  },
  {
    value: "15377",
    text: "Labranzagrande - Boyac\u00e1"
  },
  {
    value: "68385",
    text: "Land\u00e1zuri - Santander"
  },
  {
    value: "68406",
    text: "Lebrija - Santander"
  },
  {
    value: "52405",
    text: "Leiva - Nari\u00f1o"
  },
  {
    value: "50400",
    text: "Lejan\u00edas - Meta"
  },
  {
    value: "25407",
    text: "Lenguazaque - Cundinamarca"
  },
  {
    value: "73408",
    text: "L\u00e9rida - Tolima"
  },
  {
    value: "91001",
    text: "Leticia - Amazonas"
  },
  {
    value: "73411",
    text: "L\u00edbano - Tolima"
  },
  {
    value: "05411",
    text: "Liborina - Antioquia"
  },
  {
    value: "52411",
    text: "Linares - Nari\u00f1o"
  },
  {
    value: "27413",
    text: "Llor\u00f3 - Choc\u00f3"
  },
  {
    value: "19418",
    text: "L\u00f3pez de Micay - Cauca"
  },
  {
    value: "23417",
    text: "Lorica - C\u00f3rdoba"
  },
  {
    value: "52418",
    text: "Los Andes - Nari\u00f1o"
  },
  {
    value: "23419",
    text: "Los C\u00f3rdobas - C\u00f3rdoba"
  },
  {
    value: "70418",
    text: "Los Palmitos - Sucre"
  },
  {
    value: "54405",
    text: "Los Patios - Norte de Santander"
  },
  {
    value: "68418",
    text: "Los Santos - Santander"
  },
  {
    value: "54418",
    text: "Lourdes - Norte de Santander"
  },
  {
    value: "08421",
    text: "Luruaco - Atl\u00e1ntico"
  },
  {
    value: "15425",
    text: "Macanal - Boyac\u00e1"
  },
  {
    value: "68425",
    text: "Macaravita - Santander"
  },
  {
    value: "05425",
    text: "Maceo - Antioquia"
  },
  {
    value: "25426",
    text: "Machet\u00e1 - Cundinamarca"
  },
  {
    value: "25430",
    text: "Madrid - Cundinamarca"
  },
  {
    value: "13430",
    text: "Magangu\u00e9 - Bol\u00edvar"
  },
  {
    value: "52427",
    text: "Mag\u00fc\u00ed - Nari\u00f1o"
  },
  {
    value: "13433",
    text: "Mahates - Bol\u00edvar"
  },
  {
    value: "44430",
    text: "Maicao - La Guajira"
  },
  {
    value: "70429",
    text: "Majagual - Sucre"
  },
  {
    value: "68432",
    text: "M\u00e1laga - Santander"
  },
  {
    value: "08433",
    text: "Malambo - Atl\u00e1ntico"
  },
  {
    value: "52435",
    text: "Mallama - Nari\u00f1o"
  },
  {
    value: "08436",
    text: "Manat\u00ed - Atl\u00e1ntico"
  },
  {
    value: "44560",
    text: "Manaure - La Guajira"
  },
  {
    value: "20443",
    text: "Manaure Balc\u00f3n del Cesar - Cesar"
  },
  {
    value: "85139",
    text: "Man\u00ed - Casanare"
  },
  {
    value: "17001",
    text: "Manizales - Caldas"
  },
  {
    value: "25436",
    text: "Manta - Cundinamarca"
  },
  {
    value: "17433",
    text: "Manzanares - Caldas"
  },
  {
    value: "50325",
    text: "Mapirip\u00e1n - Meta"
  },
  {
    value: "94663",
    text: "Mapiripana - Guain\u00eda"
  },
  {
    value: "13440",
    text: "Margarita - Bol\u00edvar"
  },
  {
    value: "13442",
    text: "Mar\u00eda la Baja - Bol\u00edvar"
  },
  {
    value: "05440",
    text: "Marinilla - Antioquia"
  },
  {
    value: "15442",
    text: "Marip\u00ed - Boyac\u00e1"
  },
  {
    value: "17442",
    text: "Marmato - Caldas"
  },
  {
    value: "17444",
    text: "Marquetalia - Caldas"
  },
  {
    value: "66440",
    text: "Marsella - Risaralda"
  },
  {
    value: "17446",
    text: "Marulanda - Caldas"
  },
  {
    value: "68444",
    text: "Matanza - Santander"
  },
  {
    value: "05001",
    text: "Medell\u00edn - Antioquia"
  },
  {
    value: "25438",
    text: "Medina - Cundinamarca"
  },
  {
    value: "27425",
    text: "Medio Atrato - Choc\u00f3"
  },
  {
    value: "27430",
    text: "Medio Baud\u00f3 - Choc\u00f3"
  },
  {
    value: "27450",
    text: "Medio San Juan - Choc\u00f3"
  },
  {
    value: "73449",
    text: "Melgar - Tolima"
  },
  {
    value: "19450",
    text: "Mercaderes - Cauca"
  },
  {
    value: "50330",
    text: "Mesetas - Meta"
  },
  {
    value: "18460",
    text: "Mil\u00e1n - Caquet\u00e1"
  },
  {
    value: "15455",
    text: "Miraflores - Boyac\u00e1"
  },
  {
    value: "95200",
    text: "Miraflores - Guaviare"
  },
  {
    value: "19455",
    text: "Miranda - Cauca"
  },
  {
    value: "91460",
    text: "Mirit\u00ed Paran\u00e1 - Amazonas"
  },
  {
    value: "66456",
    text: "Mistrat\u00f3 - Risaralda"
  },
  {
    value: "97001",
    text: "Mit\u00fa - Vaup\u00e9s"
  },
  {
    value: "86001",
    text: "Mocoa - Putumayo"
  },
  {
    value: "68464",
    text: "Mogotes - Santander"
  },
  {
    value: "68468",
    text: "Molagavita - Santander"
  },
  {
    value: "23464",
    text: "Momil - C\u00f3rdoba"
  },
  {
    value: "13468",
    text: "Momp\u00f3s - Bol\u00edvar"
  },
  {
    value: "15464",
    text: "Mongua - Boyac\u00e1"
  },
  {
    value: "15466",
    text: "Mongu\u00ed - Boyac\u00e1"
  },
  {
    value: "15469",
    text: "Moniquir\u00e1 - Boyac\u00e1"
  },
  {
    value: "23500",
    text: "Mo\u00f1itos - C\u00f3rdoba"
  },
  {
    value: "05467",
    text: "Montebello - Antioquia"
  },
  {
    value: "13458",
    text: "Montecristo - Bol\u00edvar"
  },
  {
    value: "23466",
    text: "Montel\u00edbano - C\u00f3rdoba"
  },
  {
    value: "63470",
    text: "Montenegro - Quindio"
  },
  {
    value: "23001",
    text: "Monter\u00eda - C\u00f3rdoba"
  },
  {
    value: "85162",
    text: "Monterrey - Casanare"
  },
  {
    value: "13473",
    text: "Morales - Bol\u00edvar"
  },
  {
    value: "19473",
    text: "Morales - Cauca"
  },
  {
    value: "18479",
    text: "Morelia - Caquet\u00e1"
  },
  {
    value: "94888",
    text: "Morichal - Guain\u00eda"
  },
  {
    value: "70473",
    text: "Morroa - Sucre"
  },
  {
    value: "25473",
    text: "Mosquera - Cundinamarca"
  },
  {
    value: "52473",
    text: "Mosquera - Nari\u00f1o"
  },
  {
    value: "15476",
    text: "Motavita - Boyac\u00e1"
  },
  {
    value: "73461",
    text: "Murillo - Tolima"
  },
  {
    value: "05475",
    text: "Murind\u00f3 - Antioquia"
  },
  {
    value: "05480",
    text: "Mutat\u00e1 - Antioquia"
  },
  {
    value: "54480",
    text: "Mutiscua - Norte de Santander"
  },
  {
    value: "15480",
    text: "Muzo - Boyac\u00e1"
  },
  {
    value: "05483",
    text: "Nari\u00f1o - Antioquia"
  },
  {
    value: "25483",
    text: "Nari\u00f1o - Cundinamarca"
  },
  {
    value: "52480",
    text: "Nari\u00f1o - Nari\u00f1o"
  },
  {
    value: "41483",
    text: "N\u00e1taga - Huila"
  },
  {
    value: "73483",
    text: "Natagaima - Tolima"
  },
  {
    value: "05495",
    text: "Nech\u00ed - Antioquia"
  },
  {
    value: "05490",
    text: "Necocl\u00ed - Antioquia"
  },
  {
    value: "17486",
    text: "Neira - Caldas"
  },
  {
    value: "41001",
    text: "Neiva - Huila"
  },
  {
    value: "25486",
    text: "Nemoc\u00f3n - Cundinamarca"
  },
  {
    value: "25488",
    text: "Nilo - Cundinamarca"
  },
  {
    value: "25489",
    text: "Nimaima - Cundinamarca"
  },
  {
    value: "15491",
    text: "Nobsa - Boyac\u00e1"
  },
  {
    value: "25491",
    text: "Nocaima - Cundinamarca"
  },
  {
    value: "17495",
    text: "Norcasia - Caldas"
  },
  {
    value: "13490",
    text: "Noros\u00ed - Bol\u00edvar"
  },
  {
    value: "27491",
    text: "N\u00f3vita - Choc\u00f3"
  },
  {
    value: "47460",
    text: "Nueva Granada - Magdalena"
  },
  {
    value: "15494",
    text: "Nuevo Col\u00f3n - Boyac\u00e1"
  },
  {
    value: "85225",
    text: "Nunch\u00eda - Casanare"
  },
  {
    value: "27495",
    text: "Nuqu\u00ed - Choc\u00f3"
  },
  {
    value: "76497",
    text: "Obando - Valle del Cauca"
  },
  {
    value: "68498",
    text: "Ocamonte - Santander"
  },
  {
    value: "54498",
    text: "Oca\u00f1a - Norte de Santander"
  },
  {
    value: "68500",
    text: "Oiba - Santander"
  },
  {
    value: "15500",
    text: "Oicat\u00e1 - Boyac\u00e1"
  },
  {
    value: "05501",
    text: "Olaya - Antioquia"
  },
  {
    value: "52490",
    text: "Olaya Herrera - Nari\u00f1o"
  },
  {
    value: "68502",
    text: "Onzaga - Santander"
  },
  {
    value: "41503",
    text: "Oporapa - Huila"
  },
  {
    value: "86320",
    text: "Orito - Putumayo"
  },
  {
    value: "85230",
    text: "Orocu\u00e9 - Casanare"
  },
  {
    value: "73504",
    text: "Ortega - Tolima"
  },
  {
    value: "52506",
    text: "Ospina - Nari\u00f1o"
  },
  {
    value: "15507",
    text: "Otanche - Boyac\u00e1"
  },
  {
    value: "70508",
    text: "Ovejas - Sucre"
  },
  {
    value: "15511",
    text: "Pachavita - Boyac\u00e1"
  },
  {
    value: "25513",
    text: "Pacho - Cundinamarca"
  },
  {
    value: "97511",
    text: "Pacoa - Vaup\u00e9s"
  },
  {
    value: "17513",
    text: "P\u00e1cora - Caldas"
  },
  {
    value: "19513",
    text: "Padilla - Cauca"
  },
  {
    value: "15514",
    text: "P\u00e1ez - Boyac\u00e1"
  },
  {
    value: "19517",
    text: "P\u00e1ez - Cauca"
  },
  {
    value: "41518",
    text: "Paicol - Huila"
  },
  {
    value: "20517",
    text: "Pailitas - Cesar"
  },
  {
    value: "25518",
    text: "Paime - Cundinamarca"
  },
  {
    value: "15516",
    text: "Paipa - Boyac\u00e1"
  },
  {
    value: "15518",
    text: "Pajarito - Boyac\u00e1"
  },
  {
    value: "41524",
    text: "Palermo - Huila"
  },
  {
    value: "17524",
    text: "Palestina - Caldas"
  },
  {
    value: "41530",
    text: "Palestina - Huila"
  },
  {
    value: "68522",
    text: "Palmar - Santander"
  },
  {
    value: "08520",
    text: "Palmar de Varela - Atl\u00e1ntico"
  },
  {
    value: "68524",
    text: "Palmas del Socorro - Santander"
  },
  {
    value: "76520",
    text: "Palmira - Valle del Cauca"
  },
  {
    value: "70523",
    text: "Palmito - Sucre"
  },
  {
    value: "73520",
    text: "Palocabildo - Tolima"
  },
  {
    value: "54518",
    text: "Pamplona - Norte de Santander"
  },
  {
    value: "54520",
    text: "Pamplonita - Norte de Santander"
  },
  {
    value: "94887",
    text: "Pana Pana - Guain\u00eda"
  },
  {
    value: "25524",
    text: "Pandi - Cundinamarca"
  },
  {
    value: "15522",
    text: "Panqueba - Boyac\u00e1"
  },
  {
    value: "97777",
    text: "Papunaua - Vaup\u00e9s"
  },
  {
    value: "68533",
    text: "P\u00e1ramo - Santander"
  },
  {
    value: "25530",
    text: "Paratebueno - Cundinamarca"
  },
  {
    value: "25535",
    text: "Pasca - Cundinamarca"
  },
  {
    value: "52001",
    text: "Pasto - Nari\u00f1o"
  },
  {
    value: "19532",
    text: "Pat\u00eda - Cauca"
  },
  {
    value: "15531",
    text: "Pauna - Boyac\u00e1"
  },
  {
    value: "15533",
    text: "Paya - Boyac\u00e1"
  },
  {
    value: "85250",
    text: "Paz de Ariporo - Casanare"
  },
  {
    value: "15537",
    text: "Paz de R\u00edo - Boyac\u00e1"
  },
  {
    value: "47541",
    text: "Pedraza - Magdalena"
  },
  {
    value: "20550",
    text: "Pelaya - Cesar"
  },
  {
    value: "05541",
    text: "Pe\u00f1ol - Antioquia"
  },
  {
    value: "17541",
    text: "Pensilvania - Caldas"
  },
  {
    value: "05543",
    text: "Peque - Antioquia"
  },
  {
    value: "66001",
    text: "Pereira - Risaralda"
  },
  {
    value: "15542",
    text: "Pesca - Boyac\u00e1"
  },
  {
    value: "19533",
    text: "Piamonte - Cauca"
  },
  {
    value: "68547",
    text: "Piedecuesta - Santander"
  },
  {
    value: "73547",
    text: "Piedras - Tolima"
  },
  {
    value: "19548",
    text: "Piendam\u00f3 - Cauca"
  },
  {
    value: "63548",
    text: "Pijao - Quindio"
  },
  {
    value: "47545",
    text: "Piji\u00f1o del Carmen - Magdalena"
  },
  {
    value: "68549",
    text: "Pinchote - Santander"
  },
  {
    value: "13549",
    text: "Pinillos - Bol\u00edvar"
  },
  {
    value: "08549",
    text: "Pioj\u00f3 - Atl\u00e1ntico"
  },
  {
    value: "15550",
    text: "Pisba - Boyac\u00e1"
  },
  {
    value: "41548",
    text: "Pital - Huila"
  },
  {
    value: "41551",
    text: "Pitalito - Huila"
  },
  {
    value: "47551",
    text: "Pivijay - Magdalena"
  },
  {
    value: "73555",
    text: "Planadas - Tolima"
  },
  {
    value: "23555",
    text: "Planeta Rica - C\u00f3rdoba"
  },
  {
    value: "47555",
    text: "Plato - Magdalena"
  },
  {
    value: "52540",
    text: "Policarpa - Nari\u00f1o"
  },
  {
    value: "08558",
    text: "Polonuevo - Atl\u00e1ntico"
  },
  {
    value: "08560",
    text: "Ponedera - Atl\u00e1ntico"
  },
  {
    value: "19001",
    text: "Popay\u00e1n - Cauca"
  },
  {
    value: "85263",
    text: "Pore - Casanare"
  },
  {
    value: "52560",
    text: "Potos\u00ed - Nari\u00f1o"
  },
  {
    value: "76563",
    text: "Pradera - Valle del Cauca"
  },
  {
    value: "73563",
    text: "Prado - Tolima"
  },
  {
    value: "88564",
    text: "Providencia - Archipi\u00e9lago de San Andr\u00e9s Providencia y Santa Catalina"
  },
  {
    value: "52565",
    text: "Providencia - Nari\u00f1o"
  },
  {
    value: "20570",
    text: "Pueblo Bello - Cesar"
  },
  {
    value: "23570",
    text: "Pueblo Nuevo - C\u00f3rdoba"
  },
  {
    value: "66572",
    text: "Pueblo Rico - Risaralda"
  },
  {
    value: "05576",
    text: "Pueblorrico - Antioquia"
  },
  {
    value: "47570",
    text: "Puebloviejo - Magdalena"
  },
  {
    value: "68572",
    text: "Puente Nacional - Santander"
  },
  {
    value: "52573",
    text: "Puerres - Nari\u00f1o"
  },
  {
    value: "91530",
    text: "Puerto Alegr\u00eda - Amazonas"
  },
  {
    value: "91536",
    text: "Puerto Arica - Amazonas"
  },
  {
    value: "86568",
    text: "Puerto As\u00eds - Putumayo"
  },
  {
    value: "05579",
    text: "Puerto Berr\u00edo - Antioquia"
  },
  {
    value: "15572",
    text: "Puerto Boyac\u00e1 - Boyac\u00e1"
  },
  {
    value: "86569",
    text: "Puerto Caicedo - Putumayo"
  },
  {
    value: "99001",
    text: "Puerto Carre\u00f1o - Vichada"
  },
  {
    value: "08573",
    text: "Puerto Colombia - Atl\u00e1ntico"
  },
  {
    value: "94884",
    text: "Puerto Colombia - Guain\u00eda"
  },
  {
    value: "50450",
    text: "Puerto Concordia - Meta"
  },
  {
    value: "23574",
    text: "Puerto Escondido - C\u00f3rdoba"
  },
  {
    value: "50568",
    text: "Puerto Gait\u00e1n - Meta"
  },
  {
    value: "86571",
    text: "Puerto Guzm\u00e1n - Putumayo"
  },
  {
    value: "86573",
    text: "Puerto Legu\u00edzamo - Putumayo"
  },
  {
    value: "23580",
    text: "Puerto Libertador - C\u00f3rdoba"
  },
  {
    value: "50577",
    text: "Puerto Lleras - Meta"
  },
  {
    value: "50573",
    text: "Puerto L\u00f3pez - Meta"
  },
  {
    value: "05585",
    text: "Puerto Nare - Antioquia"
  },
  {
    value: "91540",
    text: "Puerto Nari\u00f1o - Amazonas"
  },
  {
    value: "68573",
    text: "Puerto Parra - Santander"
  },
  {
    value: "18592",
    text: "Puerto Rico - Caquet\u00e1"
  },
  {
    value: "50590",
    text: "Puerto Rico - Meta"
  },
  {
    value: "81591",
    text: "Puerto Rond\u00f3n - Arauca"
  },
  {
    value: "25572",
    text: "Puerto Salgar - Cundinamarca"
  },
  {
    value: "91669",
    text: "Puerto Santander - Amazonas"
  },
  {
    value: "54553",
    text: "Puerto Santander - Norte de Santander"
  },
  {
    value: "19573",
    text: "Puerto Tejada - Cauca"
  },
  {
    value: "05591",
    text: "Puerto Triunfo - Antioquia"
  },
  {
    value: "68575",
    text: "Puerto Wilches - Santander"
  },
  {
    value: "25580",
    text: "Pul\u00ed - Cundinamarca"
  },
  {
    value: "52585",
    text: "Pupiales - Nari\u00f1o"
  },
  {
    value: "19585",
    text: "Purac\u00e9 - Cauca"
  },
  {
    value: "73585",
    text: "Purificaci\u00f3n - Tolima"
  },
  {
    value: "23586",
    text: "Pur\u00edsima de la Concepci\u00f3n - C\u00f3rdoba"
  },
  {
    value: "25592",
    text: "Quebradanegra - Cundinamarca"
  },
  {
    value: "25594",
    text: "Quetame - Cundinamarca"
  },
  {
    value: "27001",
    text: "Quibd\u00f3 - Choc\u00f3"
  },
  {
    value: "63594",
    text: "Quimbaya - Quindio"
  },
  {
    value: "66594",
    text: "Quinch\u00eda - Risaralda"
  },
  {
    value: "15580",
    text: "Qu\u00edpama - Boyac\u00e1"
  },
  {
    value: "25596",
    text: "Quipile - Cundinamarca"
  },
  {
    value: "54599",
    text: "Ragonvalia - Norte de Santander"
  },
  {
    value: "15599",
    text: "Ramiriqu\u00ed - Boyac\u00e1"
  },
  {
    value: "15600",
    text: "R\u00e1quira - Boyac\u00e1"
  },
  {
    value: "85279",
    text: "Recetor - Casanare"
  },
  {
    value: "13580",
    text: "Regidor - Bol\u00edvar"
  },
  {
    value: "05604",
    text: "Remedios - Antioquia"
  },
  {
    value: "47605",
    text: "Remolino - Magdalena"
  },
  {
    value: "08606",
    text: "Repel\u00f3n - Atl\u00e1ntico"
  },
  {
    value: "50606",
    text: "Restrepo - Meta"
  },
  {
    value: "76606",
    text: "Restrepo - Valle del Cauca"
  },
  {
    value: "05607",
    text: "Retiro - Antioquia"
  },
  {
    value: "25612",
    text: "Ricaurte - Cundinamarca"
  },
  {
    value: "52612",
    text: "Ricaurte - Nari\u00f1o"
  },
  {
    value: "20614",
    text: "R\u00edo de Oro - Cesar"
  },
  {
    value: "27580",
    text: "R\u00edo Ir\u00f3 - Choc\u00f3"
  },
  {
    value: "27600",
    text: "R\u00edo Quito - Choc\u00f3"
  },
  {
    value: "13600",
    text: "R\u00edo Viejo - Bol\u00edvar"
  },
  {
    value: "73616",
    text: "Rioblanco - Tolima"
  },
  {
    value: "76616",
    text: "Riofr\u00edo - Valle del Cauca"
  },
  {
    value: "44001",
    text: "Riohacha - La Guajira"
  },
  {
    value: "05615",
    text: "Rionegro - Antioquia"
  },
  {
    value: "68615",
    text: "Rionegro - Santander"
  },
  {
    value: "17614",
    text: "Riosucio - Caldas"
  },
  {
    value: "27615",
    text: "Riosucio - Choc\u00f3"
  },
  {
    value: "17616",
    text: "Risaralda - Caldas"
  },
  {
    value: "41615",
    text: "Rivera - Huila"
  },
  {
    value: "52621",
    text: "Roberto Pay\u00e1n - Nari\u00f1o"
  },
  {
    value: "76622",
    text: "Roldanillo - Valle del Cauca"
  },
  {
    value: "73622",
    text: "Roncesvalles - Tolima"
  },
  {
    value: "15621",
    text: "Rond\u00f3n - Boyac\u00e1"
  },
  {
    value: "19622",
    text: "Rosas - Cauca"
  },
  {
    value: "73624",
    text: "Rovira - Tolima"
  },
  {
    value: "68655",
    text: "Sabana de Torres - Santander"
  },
  {
    value: "08634",
    text: "Sabanagrande - Atl\u00e1ntico"
  },
  {
    value: "05628",
    text: "Sabanalarga - Antioquia"
  },
  {
    value: "08638",
    text: "Sabanalarga - Atl\u00e1ntico"
  },
  {
    value: "85300",
    text: "Sabanalarga - Casanare"
  },
  {
    value: "47660",
    text: "Sabanas de San \u00c1ngel - Magdalena"
  },
  {
    value: "05631",
    text: "Sabaneta - Antioquia"
  },
  {
    value: "15632",
    text: "Saboy\u00e1 - Boyac\u00e1"
  },
  {
    value: "85315",
    text: "S\u00e1cama - Casanare"
  },
  {
    value: "15638",
    text: "S\u00e1chica - Boyac\u00e1"
  },
  {
    value: "23660",
    text: "Sahag\u00fan - C\u00f3rdoba"
  },
  {
    value: "41660",
    text: "Saladoblanco - Huila"
  },
  {
    value: "17653",
    text: "Salamina - Caldas"
  },
  {
    value: "47675",
    text: "Salamina - Magdalena"
  },
  {
    value: "54660",
    text: "Salazar - Norte de Santander"
  },
  {
    value: "73671",
    text: "Salda\u00f1a - Tolima"
  },
  {
    value: "63690",
    text: "Salento - Quindio"
  },
  {
    value: "05642",
    text: "Salgar - Antioquia"
  },
  {
    value: "15646",
    text: "Samac\u00e1 - Boyac\u00e1"
  },
  {
    value: "17662",
    text: "Saman\u00e1 - Caldas"
  },
  {
    value: "52678",
    text: "Samaniego - Nari\u00f1o"
  },
  {
    value: "70670",
    text: "Sampu\u00e9s - Sucre"
  },
  {
    value: "41668",
    text: "San Agust\u00edn - Huila"
  },
  {
    value: "20710",
    text: "San Alberto - Cesar"
  },
  {
    value: "88001",
    text: "San Andr\u00e9s - Archipi\u00e9lago de San Andr\u00e9s Providencia y Santa Catalina"
  },
  {
    value: "68669",
    text: "San Andr\u00e9s - Santander"
  },
  {
    value: "05647",
    text: "San Andr\u00e9s de Cuerqu\u00eda - Antioquia"
  },
  {
    value: "23670",
    text: "San Andr\u00e9s de Sotavento - C\u00f3rdoba"
  },
  {
    value: "52835",
    text: "San Andr\u00e9s de Tumaco - Nari\u00f1o"
  },
  {
    value: "23672",
    text: "San Antero - C\u00f3rdoba"
  },
  {
    value: "73675",
    text: "San Antonio - Tolima"
  },
  {
    value: "25645",
    text: "San Antonio del Tequendama - Cundinamarca"
  },
  {
    value: "68673",
    text: "San Benito - Santander"
  },
  {
    value: "70678",
    text: "San Benito abad - Sucre"
  },
  {
    value: "25649",
    text: "San Bernardo - Cundinamarca"
  },
  {
    value: "52685",
    text: "San Bernardo - Nari\u00f1o"
  },
  {
    value: "23675",
    text: "San Bernardo del Viento - C\u00f3rdoba"
  },
  {
    value: "54670",
    text: "San Calixto - Norte de Santander"
  },
  {
    value: "05649",
    text: "San Carlos - Antioquia"
  },
  {
    value: "23678",
    text: "San Carlos - C\u00f3rdoba"
  },
  {
    value: "50680",
    text: "San Carlos de Guaroa - Meta"
  },
  {
    value: "25653",
    text: "San Cayetano - Cundinamarca"
  },
  {
    value: "54673",
    text: "San Cayetano - Norte de Santander"
  },
  {
    value: "13620",
    text: "San Crist\u00f3bal - Bol\u00edvar"
  },
  {
    value: "20750",
    text: "San Diego - Cesar"
  },
  {
    value: "15660",
    text: "San Eduardo - Boyac\u00e1"
  },
  {
    value: "13647",
    text: "San Estanislao - Bol\u00edvar"
  },
  {
    value: "94883",
    text: "San Felipe - Guain\u00eda"
  },
  {
    value: "13650",
    text: "San Fernando - Bol\u00edvar"
  },
  {
    value: "05652",
    text: "San Francisco - Antioquia"
  },
  {
    value: "25658",
    text: "San Francisco - Cundinamarca"
  },
  {
    value: "86755",
    text: "San Francisco - Putumayo"
  },
  {
    value: "68679",
    text: "San Gil - Santander"
  },
  {
    value: "13654",
    text: "San Jacinto - Bol\u00edvar"
  },
  {
    value: "13655",
    text: "San Jacinto del Cauca - Bol\u00edvar"
  },
  {
    value: "05656",
    text: "San Jer\u00f3nimo - Antioquia"
  },
  {
    value: "68682",
    text: "San Joaqu\u00edn - Santander"
  },
  {
    value: "17665",
    text: "San Jos\u00e9 - Caldas"
  },
  {
    value: "68684",
    text: "San Jos\u00e9 de Miranda - Santander"
  },
  {
    value: "15664",
    text: "San Jos\u00e9 de Pare - Boyac\u00e1"
  },
  {
    value: "23682",
    text: "San Jos\u00e9 de Ur\u00e9 - C\u00f3rdoba"
  },
  {
    value: "18610",
    text: "San Jos\u00e9 del Fragua - Caquet\u00e1"
  },
  {
    value: "95001",
    text: "San Jos\u00e9 del Guaviare - Guaviare"
  },
  {
    value: "27660",
    text: "San Jos\u00e9 del Palmar - Choc\u00f3"
  },
  {
    value: "05658",
    text: "San Jos\u00e9 la Monta\u00f1a - Antioquia"
  },
  {
    value: "50683",
    text: "San Juan de Arama - Meta"
  },
  {
    value: "70702",
    text: "San Juan de Betulia - Sucre"
  },
  {
    value: "25662",
    text: "San Juan de Rioseco - Cundinamarca"
  },
  {
    value: "05659",
    text: "San Juan de Urab\u00e1 - Antioquia"
  },
  {
    value: "44650",
    text: "San Juan del Cesar - La Guajira"
  },
  {
    value: "13657",
    text: "San Juan Nepomuceno - Bol\u00edvar"
  },
  {
    value: "50686",
    text: "San Juanito - Meta"
  },
  {
    value: "52687",
    text: "San Lorenzo - Nari\u00f1o"
  },
  {
    value: "05660",
    text: "San Luis - Antioquia"
  },
  {
    value: "73678",
    text: "San Luis - Tolima"
  },
  {
    value: "50223",
    text: "San Luis de Cubarral - Meta"
  },
  {
    value: "15667",
    text: "San Luis de Gaceno - Boyac\u00e1"
  },
  {
    value: "85325",
    text: "San Luis de Palenque - Casanare"
  },
  {
    value: "70742",
    text: "San Luis de Sinc\u00e9 - Sucre"
  },
  {
    value: "70708",
    text: "San Marcos - Sucre"
  },
  {
    value: "20770",
    text: "San Mart\u00edn - Cesar"
  },
  {
    value: "50689",
    text: "San Mart\u00edn - Meta"
  },
  {
    value: "13667",
    text: "San Mart\u00edn de Loba - Bol\u00edvar"
  },
  {
    value: "15673",
    text: "San Mateo - Boyac\u00e1"
  },
  {
    value: "86757",
    text: "San Miguel - Putumayo"
  },
  {
    value: "68686",
    text: "San Miguel - Santander"
  },
  {
    value: "15676",
    text: "San Miguel de Sema - Boyac\u00e1"
  },
  {
    value: "70713",
    text: "San Onofre - Sucre"
  },
  {
    value: "13670",
    text: "San Pablo - Bol\u00edvar"
  },
  {
    value: "52693",
    text: "San Pablo - Nari\u00f1o"
  },
  {
    value: "15681",
    text: "San Pablo de Borbur - Boyac\u00e1"
  },
  {
    value: "70717",
    text: "San Pedro - Sucre"
  },
  {
    value: "76670",
    text: "San Pedro - Valle del Cauca"
  },
  {
    value: "52694",
    text: "San Pedro de Cartago - Nari\u00f1o"
  },
  {
    value: "05665",
    text: "San Pedro de Urab\u00e1 - Antioquia"
  },
  {
    value: "05664",
    text: "San Pedro los Milagros - Antioquia"
  },
  {
    value: "23686",
    text: "San Pelayo - C\u00f3rdoba"
  },
  {
    value: "05667",
    text: "San Rafael - Antioquia"
  },
  {
    value: "05670",
    text: "San Roque - Antioquia"
  },
  {
    value: "19693",
    text: "San Sebasti\u00e1n - Cauca"
  },
  {
    value: "47692",
    text: "San Sebasti\u00e1n de Buenavista - Magdalena"
  },
  {
    value: "73443",
    text: "San Sebasti\u00e1n de Mariquita - Tolima"
  },
  {
    value: "68689",
    text: "San Vicente de Chucur\u00ed - Santander"
  },
  {
    value: "18753",
    text: "San Vicente del Cagu\u00e1n - Caquet\u00e1"
  },
  {
    value: "05674",
    text: "San Vicente Ferrer - Antioquia"
  },
  {
    value: "47703",
    text: "San Zen\u00f3n - Magdalena"
  },
  {
    value: "52683",
    text: "Sandon\u00e1 - Nari\u00f1o"
  },
  {
    value: "47707",
    text: "Santa Ana - Magdalena"
  },
  {
    value: "05679",
    text: "Santa B\u00e1rbara - Antioquia"
  },
  {
    value: "52696",
    text: "Santa B\u00e1rbara - Nari\u00f1o"
  },
  {
    value: "68705",
    text: "Santa B\u00e1rbara - Santander"
  },
  {
    value: "47720",
    text: "Santa B\u00e1rbara de Pinto - Magdalena"
  },
  {
    value: "13673",
    text: "Santa Catalina - Bol\u00edvar"
  },
  {
    value: "05042",
    text: "Santa F\u00e9 de Antioquia - Antioquia"
  },
  {
    value: "68720",
    text: "Santa Helena del Op\u00f3n - Santander"
  },
  {
    value: "73686",
    text: "Santa Isabel - Tolima"
  },
  {
    value: "08675",
    text: "Santa Luc\u00eda - Atl\u00e1ntico"
  },
  {
    value: "15690",
    text: "Santa Mar\u00eda - Boyac\u00e1"
  },
  {
    value: "41676",
    text: "Santa Mar\u00eda - Huila"
  },
  {
    value: "47001",
    text: "Santa Marta - Magdalena"
  },
  {
    value: "13683",
    text: "Santa Rosa - Bol\u00edvar"
  },
  {
    value: "19701",
    text: "Santa Rosa - Cauca"
  },
  {
    value: "66682",
    text: "Santa Rosa de Cabal - Risaralda"
  },
  {
    value: "05686",
    text: "Santa Rosa de Osos - Antioquia"
  },
  {
    value: "15693",
    text: "Santa Rosa de Viterbo - Boyac\u00e1"
  },
  {
    value: "13688",
    text: "Santa Rosa del Sur - Bol\u00edvar"
  },
  {
    value: "99624",
    text: "Santa Rosal\u00eda - Vichada"
  },
  {
    value: "15696",
    text: "Santa Sof\u00eda - Boyac\u00e1"
  },
  {
    value: "52699",
    text: "Santacruz - Nari\u00f1o"
  },
  {
    value: "15686",
    text: "Santana - Boyac\u00e1"
  },
  {
    value: "19698",
    text: "Santander de Quilichao - Cauca"
  },
  {
    value: "54680",
    text: "Santiago - Norte de Santander"
  },
  {
    value: "86760",
    text: "Santiago - Putumayo"
  },
  {
    value: "70820",
    text: "Santiago de Tol\u00fa - Sucre"
  },
  {
    value: "05690",
    text: "Santo Domingo - Antioquia"
  },
  {
    value: "08685",
    text: "Santo Tom\u00e1s - Atl\u00e1ntico"
  },
  {
    value: "66687",
    text: "Santuario - Risaralda"
  },
  {
    value: "52720",
    text: "Sapuyes - Nari\u00f1o"
  },
  {
    value: "81736",
    text: "Saravena - Arauca"
  },
  {
    value: "54720",
    text: "Sardinata - Norte de Santander"
  },
  {
    value: "25718",
    text: "Sasaima - Cundinamarca"
  },
  {
    value: "15720",
    text: "Sativanorte - Boyac\u00e1"
  },
  {
    value: "15723",
    text: "Sativasur - Boyac\u00e1"
  },
  {
    value: "05736",
    text: "Segovia - Antioquia"
  },
  {
    value: "25736",
    text: "Sesquil\u00e9 - Cundinamarca"
  },
  {
    value: "76736",
    text: "Sevilla - Valle del Cauca"
  },
  {
    value: "15740",
    text: "Siachoque - Boyac\u00e1"
  },
  {
    value: "25740",
    text: "Sibat\u00e9 - Cundinamarca"
  },
  {
    value: "86749",
    text: "Sibundoy - Putumayo"
  },
  {
    value: "54743",
    text: "Silos - Norte de Santander"
  },
  {
    value: "25743",
    text: "Silvania - Cundinamarca"
  },
  {
    value: "19743",
    text: "Silvia - Cauca"
  },
  {
    value: "68745",
    text: "Simacota - Santander"
  },
  {
    value: "25745",
    text: "Simijaca - Cundinamarca"
  },
  {
    value: "13744",
    text: "Simit\u00ed - Bol\u00edvar"
  },
  {
    value: "70001",
    text: "Sincelejo - Sucre"
  },
  {
    value: "27745",
    text: "Sip\u00ed - Choc\u00f3"
  },
  {
    value: "47745",
    text: "Sitionuevo - Magdalena"
  },
  {
    value: "25754",
    text: "Soacha - Cundinamarca"
  },
  {
    value: "15753",
    text: "Soat\u00e1 - Boyac\u00e1"
  },
  {
    value: "15757",
    text: "Socha - Boyac\u00e1"
  },
  {
    value: "68755",
    text: "Socorro - Santander"
  },
  {
    value: "15755",
    text: "Socot\u00e1 - Boyac\u00e1"
  },
  {
    value: "15759",
    text: "Sogamoso - Boyac\u00e1"
  },
  {
    value: "18756",
    text: "Solano - Caquet\u00e1"
  },
  {
    value: "08758",
    text: "Soledad - Atl\u00e1ntico"
  },
  {
    value: "18785",
    text: "Solita - Caquet\u00e1"
  },
  {
    value: "15761",
    text: "Somondoco - Boyac\u00e1"
  },
  {
    value: "05756",
    text: "Sons\u00f3n - Antioquia"
  },
  {
    value: "05761",
    text: "Sopetr\u00e1n - Antioquia"
  },
  {
    value: "13760",
    text: "Soplaviento - Bol\u00edvar"
  },
  {
    value: "25758",
    text: "Sop\u00f3 - Cundinamarca"
  },
  {
    value: "15762",
    text: "Sora - Boyac\u00e1"
  },
  {
    value: "15764",
    text: "Sorac\u00e1 - Boyac\u00e1"
  },
  {
    value: "15763",
    text: "Sotaquir\u00e1 - Boyac\u00e1"
  },
  {
    value: "19760",
    text: "Sotara - Cauca"
  },
  {
    value: "68770",
    text: "Suaita - Santander"
  },
  {
    value: "08770",
    text: "Suan - Atl\u00e1ntico"
  },
  {
    value: "19780",
    text: "Su\u00e1rez - Cauca"
  },
  {
    value: "73770",
    text: "Su\u00e1rez - Tolima"
  },
  {
    value: "41770",
    text: "Suaza - Huila"
  },
  {
    value: "25769",
    text: "Subachoque - Cundinamarca"
  },
  {
    value: "19785",
    text: "Sucre - Cauca"
  },
  {
    value: "68773",
    text: "Sucre - Santander"
  },
  {
    value: "70771",
    text: "Sucre - Sucre"
  },
  {
    value: "25772",
    text: "Suesca - Cundinamarca"
  },
  {
    value: "25777",
    text: "Supat\u00e1 - Cundinamarca"
  },
  {
    value: "17777",
    text: "Sup\u00eda - Caldas"
  },
  {
    value: "68780",
    text: "Surat\u00e1 - Santander"
  },
  {
    value: "25779",
    text: "Susa - Cundinamarca"
  },
  {
    value: "15774",
    text: "Susac\u00f3n - Boyac\u00e1"
  },
  {
    value: "15776",
    text: "Sutamarch\u00e1n - Boyac\u00e1"
  },
  {
    value: "25781",
    text: "Sutatausa - Cundinamarca"
  },
  {
    value: "15778",
    text: "Sutatenza - Boyac\u00e1"
  },
  {
    value: "25785",
    text: "Tabio - Cundinamarca"
  },
  {
    value: "27787",
    text: "Tad\u00f3 - Choc\u00f3"
  },
  {
    value: "13780",
    text: "Talaigua Nuevo - Bol\u00edvar"
  },
  {
    value: "20787",
    text: "Tamalameque - Cesar"
  },
  {
    value: "85400",
    text: "T\u00e1mara - Casanare"
  },
  {
    value: "81794",
    text: "Tame - Arauca"
  },
  {
    value: "05789",
    text: "T\u00e1mesis - Antioquia"
  },
  {
    value: "52786",
    text: "Taminango - Nari\u00f1o"
  },
  {
    value: "52788",
    text: "Tangua - Nari\u00f1o"
  },
  {
    value: "97666",
    text: "Taraira - Vaup\u00e9s"
  },
  {
    value: "91798",
    text: "Tarapac\u00e1 - Amazonas"
  },
  {
    value: "05790",
    text: "Taraz\u00e1 - Antioquia"
  },
  {
    value: "41791",
    text: "Tarqui - Huila"
  },
  {
    value: "05792",
    text: "Tarso - Antioquia"
  },
  {
    value: "15790",
    text: "Tasco - Boyac\u00e1"
  },
  {
    value: "85410",
    text: "Tauramena - Casanare"
  },
  {
    value: "25793",
    text: "Tausa - Cundinamarca"
  },
  {
    value: "41799",
    text: "Tello - Huila"
  },
  {
    value: "25797",
    text: "Tena - Cundinamarca"
  },
  {
    value: "47798",
    text: "Tenerife - Magdalena"
  },
  {
    value: "25799",
    text: "Tenjo - Cundinamarca"
  },
  {
    value: "15798",
    text: "Tenza - Boyac\u00e1"
  },
  {
    value: "54800",
    text: "Teorama - Norte de Santander"
  },
  {
    value: "41801",
    text: "Teruel - Huila"
  },
  {
    value: "41797",
    text: "Tesalia - Huila"
  },
  {
    value: "25805",
    text: "Tibacuy - Cundinamarca"
  },
  {
    value: "15804",
    text: "Tiban\u00e1 - Boyac\u00e1"
  },
  {
    value: "15806",
    text: "Tibasosa - Boyac\u00e1"
  },
  {
    value: "25807",
    text: "Tibirita - Cundinamarca"
  },
  {
    value: "54810",
    text: "Tib\u00fa - Norte de Santander"
  },
  {
    value: "23807",
    text: "Tierralta - C\u00f3rdoba"
  },
  {
    value: "41807",
    text: "Timan\u00e1 - Huila"
  },
  {
    value: "19807",
    text: "Timb\u00edo - Cauca"
  },
  {
    value: "19809",
    text: "Timbiqu\u00ed - Cauca"
  },
  {
    value: "15808",
    text: "Tinjac\u00e1 - Boyac\u00e1"
  },
  {
    value: "15810",
    text: "Tipacoque - Boyac\u00e1"
  },
  {
    value: "13810",
    text: "Tiquisio - Bol\u00edvar"
  },
  {
    value: "05809",
    text: "Titirib\u00ed - Antioquia"
  },
  {
    value: "15814",
    text: "Toca - Boyac\u00e1"
  },
  {
    value: "25815",
    text: "Tocaima - Cundinamarca"
  },
  {
    value: "25817",
    text: "Tocancip\u00e1 - Cundinamarca"
  },
  {
    value: "15816",
    text: "Tog\u00fc\u00ed - Boyac\u00e1"
  },
  {
    value: "05819",
    text: "Toledo - Antioquia"
  },
  {
    value: "54820",
    text: "Toledo - Norte de Santander"
  },
  {
    value: "70823",
    text: "Tol\u00fa Viejo - Sucre"
  },
  {
    value: "68820",
    text: "Tona - Santander"
  },
  {
    value: "15820",
    text: "T\u00f3paga - Boyac\u00e1"
  },
  {
    value: "25823",
    text: "Topaip\u00ed - Cundinamarca"
  },
  {
    value: "19821",
    text: "Torib\u00edo - Cauca"
  },
  {
    value: "76823",
    text: "Toro - Valle del Cauca"
  },
  {
    value: "15822",
    text: "Tota - Boyac\u00e1"
  },
  {
    value: "19824",
    text: "Totor\u00f3 - Cauca"
  },
  {
    value: "85430",
    text: "Trinidad - Casanare"
  },
  {
    value: "76828",
    text: "Trujillo - Valle del Cauca"
  },
  {
    value: "08832",
    text: "Tubar\u00e1 - Atl\u00e1ntico"
  },
  {
    value: "23815",
    text: "Tuch\u00edn - C\u00f3rdoba"
  },
  {
    value: "76834",
    text: "Tulu\u00e1 - Valle del Cauca"
  },
  {
    value: "15001",
    text: "Tunja - Boyac\u00e1"
  },
  {
    value: "15832",
    text: "Tunungu\u00e1 - Boyac\u00e1"
  },
  {
    value: "52838",
    text: "T\u00faquerres - Nari\u00f1o"
  },
  {
    value: "13836",
    text: "Turbaco - Bol\u00edvar"
  },
  {
    value: "13838",
    text: "Turban\u00e1 - Bol\u00edvar"
  },
  {
    value: "05837",
    text: "Turbo - Antioquia"
  },
  {
    value: "15835",
    text: "Turmequ\u00e9 - Boyac\u00e1"
  },
  {
    value: "15837",
    text: "Tuta - Boyac\u00e1"
  },
  {
    value: "15839",
    text: "Tutaz\u00e1 - Boyac\u00e1"
  },
  {
    value: "25839",
    text: "Ubal\u00e1 - Cundinamarca"
  },
  {
    value: "25841",
    text: "Ubaque - Cundinamarca"
  },
  {
    value: "76845",
    text: "Ulloa - Valle del Cauca"
  },
  {
    value: "15842",
    text: "\u00dambita - Boyac\u00e1"
  },
  {
    value: "25845",
    text: "Une - Cundinamarca"
  },
  {
    value: "27800",
    text: "Ungu\u00eda - Choc\u00f3"
  },
  {
    value: "27810",
    text: "Uni\u00f3n Panamericana - Choc\u00f3"
  },
  {
    value: "05842",
    text: "Uramita - Antioquia"
  },
  {
    value: "50370",
    text: "Uribe - Meta"
  },
  {
    value: "44847",
    text: "Uribia - La Guajira"
  },
  {
    value: "05847",
    text: "Urrao - Antioquia"
  },
  {
    value: "44855",
    text: "Urumita - La Guajira"
  },
  {
    value: "08849",
    text: "Usiacur\u00ed - Atl\u00e1ntico"
  },
  {
    value: "25851",
    text: "\u00datica - Cundinamarca"
  },
  {
    value: "05854",
    text: "Valdivia - Antioquia"
  },
  {
    value: "23855",
    text: "Valencia - C\u00f3rdoba"
  },
  {
    value: "68855",
    text: "Valle de San Jos\u00e9 - Santander"
  },
  {
    value: "73854",
    text: "Valle de San Juan - Tolima"
  },
  {
    value: "86865",
    text: "Valle del Guamuez - Putumayo"
  },
  {
    value: "20001",
    text: "Valledupar - Cesar"
  },
  {
    value: "05856",
    text: "Valpara\u00edso - Antioquia"
  },
  {
    value: "18860",
    text: "Valpara\u00edso - Caquet\u00e1"
  },
  {
    value: "05858",
    text: "Vegach\u00ed - Antioquia"
  },
  {
    value: "68861",
    text: "V\u00e9lez - Santander"
  },
  {
    value: "73861",
    text: "Venadillo - Tolima"
  },
  {
    value: "05861",
    text: "Venecia - Antioquia"
  },
  {
    value: "25506",
    text: "Venecia - Cundinamarca"
  },
  {
    value: "15861",
    text: "Ventaquemada - Boyac\u00e1"
  },
  {
    value: "25862",
    text: "Vergara - Cundinamarca"
  },
  {
    value: "76863",
    text: "Versalles - Valle del Cauca"
  },
  {
    value: "68867",
    text: "Vetas - Santander"
  },
  {
    value: "25867",
    text: "Vian\u00ed - Cundinamarca"
  },
  {
    value: "17867",
    text: "Victoria - Caldas"
  },
  {
    value: "05873",
    text: "Vig\u00eda del Fuerte - Antioquia"
  },
  {
    value: "76869",
    text: "Vijes - Valle del Cauca"
  },
  {
    value: "54871",
    text: "Villa Caro - Norte de Santander"
  },
  {
    value: "25843",
    text: "Villa de de Ubat\u00e9 - Cundinamarca"
  },
  {
    value: "15407",
    text: "Villa de Leyva - Boyac\u00e1"
  },
  {
    value: "54874",
    text: "Villa del Rosario - Norte de Santander"
  },
  {
    value: "19845",
    text: "Villa rica - Cauca"
  },
  {
    value: "86885",
    text: "Villagarz\u00f3n - Putumayo"
  },
  {
    value: "25871",
    text: "Villag\u00f3mez - Cundinamarca"
  },
  {
    value: "73870",
    text: "Villahermosa - Tolima"
  },
  {
    value: "17873",
    text: "Villamar\u00eda - Caldas"
  },
  {
    value: "13873",
    text: "Villanueva - Bol\u00edvar"
  },
  {
    value: "85440",
    text: "Villanueva - Casanare"
  },
  {
    value: "44874",
    text: "Villanueva - La Guajira"
  },
  {
    value: "68872",
    text: "Villanueva - Santander"
  },
  {
    value: "25873",
    text: "Villapinz\u00f3n - Cundinamarca"
  },
  {
    value: "73873",
    text: "Villarrica - Tolima"
  },
  {
    value: "50001",
    text: "Villavicencio - Meta"
  },
  {
    value: "41872",
    text: "Villavieja - Huila"
  },
  {
    value: "25875",
    text: "Villeta - Cundinamarca"
  },
  {
    value: "25878",
    text: "Viot\u00e1 - Cundinamarca"
  },
  {
    value: "15879",
    text: "Viracach\u00e1 - Boyac\u00e1"
  },
  {
    value: "50711",
    text: "Vistahermosa - Meta"
  },
  {
    value: "17877",
    text: "Viterbo - Caldas"
  },
  {
    value: "25885",
    text: "Yacop\u00ed - Cundinamarca"
  },
  {
    value: "52885",
    text: "Yacuanquer - Nari\u00f1o"
  },
  {
    value: "41885",
    text: "Yaguar\u00e1 - Huila"
  },
  {
    value: "05885",
    text: "Yal\u00ed - Antioquia"
  },
  {
    value: "05887",
    text: "Yarumal - Antioquia"
  },
  {
    value: "97889",
    text: "Yavarat\u00e9 - Vaup\u00e9s"
  },
  {
    value: "05890",
    text: "Yolomb\u00f3 - Antioquia"
  },
  {
    value: "05893",
    text: "Yond\u00f3 - Antioquia"
  },
  {
    value: "85001",
    text: "Yopal - Casanare"
  },
  {
    value: "76890",
    text: "Yotoco - Valle del Cauca"
  },
  {
    value: "76892",
    text: "Yumbo - Valle del Cauca"
  },
  {
    value: "13894",
    text: "Zambrano - Bol\u00edvar"
  },
  {
    value: "68895",
    text: "Zapatoca - Santander"
  },
  {
    value: "47960",
    text: "Zapay\u00e1n - Magdalena"
  },
  {
    value: "05895",
    text: "Zaragoza - Antioquia"
  },
  {
    value: "76895",
    text: "Zarzal - Valle del Cauca"
  },
  {
    value: "15897",
    text: "Zetaquira - Boyac\u00e1"
  },
  {
    value: "25898",
    text: "Zipac\u00f3n - Cundinamarca"
  },
  {
    value: "25899",
    text: "Zipaquir\u00e1 - Cundinamarca"
  },
  {
    value: "47980",
    text: "Zona Bananera - Magdalena"
  }
]
export default listaMunicipios